import axios from 'axios';

import { DadataAdressSuggestion } from '@/types/dadata';

/** Апи получения локации из dadata */
export async function getLocationFromDadata(params: {
	query: string;
	to_bound: {
		value: string;
	};
	from_bound?: {
		value: string;
	};
}) {
	try {
		const { data } = await axios.post<DadataAdressSuggestion>(
			'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
			params,
			{
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
					Authorization: `Token ${process.env.DADATA}`,
				},
				withCredentials: false,
			},
		);
		return data;
	} catch (error) {
		throw 'Ошибка получения адреса';
	}
}
